module.exports = __webpack_public_path__ + "img/home-bg.63ecc94a.jpeg";